// Mock data for SWAPPED Character NFT site

export const projectName = "SWAPPED";
export const projectFull = "Swapped Character";

// User-uploaded logo image
export const logoImg =
  "https://customer-assets.emergentagent.com/job_character-showcase-20/artifacts/lhy5squ3_Picsart_26-05-11_17-13-33-412.jpg";

// Forest / mountain hero background
export const forestImg =
  "https://customer-assets.emergentagent.com/job_character-showcase-20/artifacts/ldedl1g9_MV5BNDk5OGUyODAtZDdmNS00ZWU4LWFkYjktZmU5MGMwZWYyZjNlXkEyXkFqcGc%40._V1_FMjpg_UX1894_.jpg.jpeg";

// First sampul (original SWAPPED scene)
export const coverImage =
  "https://customer-assets.emergentagent.com/job_character-showcase-20/artifacts/xi6xn62d_Picsart_26-05-11_16-30-58-791.jpg";

// Teaser video (under synopsis)
export const teaserVideo =
  "https://customer-assets.emergentagent.com/job_character-showcase-20/artifacts/ljbn0iue_VN20260511_232941.mp4";

export const heroTagline = "Characters from the Netflix film story";

export const synopsis =
  "Swapped is a 2026 American animated fantasy adventure comedy film directed by Nathan Greno and written by John Whittington, Christian Magalhaes, and Robert Snow, who all co-wrote the story with Greno and Adam Karp. Produced by Skydance Animation, the film features the voices of Michael B. Jordan, Juno Temple, Tracy Morgan, Cedric the Entertainer, and Justina Machado. It was released on Netflix and select theaters on May 1, 2026, and received mixed reviews from critics.";

export const mintInfo = [
  { label: "MINT DATE", value: "TBA", pulse: true },
  { label: "PRICE", value: "FREE MINT", color: "#F2C829", suffix: "" },
  { label: "SUPPLY", value: "333", color: "#F4EBCC" },
  { label: "CHAIN", value: "ETHEREUM", color: "#A7D88A" },
];

// Image URLs from earlier uploads
const IMG_OLLIE =
  "https://customer-assets.emergentagent.com/job_character-showcase-20/artifacts/5lprcjvb_ChatGPT%20Image%2011%20Mei%202026%2C%2011.59.39.png";
const IMG_IVY =
  "https://customer-assets.emergentagent.com/job_character-showcase-20/artifacts/kjuldyxl_ChatGPT%20Image%2011%20Mei%202026%2C%2012.56.40.png";
const IMG_BOOGLE =
  "https://customer-assets.emergentagent.com/job_character-showcase-20/artifacts/pq859g43_ChatGPT%20Image%2011%20Mei%202026%2C%2013.02.33.png";
const IMG_FIREWOLF =
  "https://customer-assets.emergentagent.com/job_character-showcase-20/artifacts/yvqb8tzq_ChatGPT%20Image%2011%20Mei%202026%2C%2015.50.38.png";

// 4 NFT characters
export const characters = [
  {
    id: 1,
    name: "OLLIE",
    role: "The Reefkeeper",
    tag: "Drifter of Tides",
    desc: "A calm and curious soul with a heart as wide as the open sea. Ollie greets every wave with a smile and a story.",
    img: IMG_OLLIE,
    accent: "#C97A12",
    tint: "#FBE7B5",
  },
  {
    id: 2,
    name: "IVY",
    role: "The Burning Stag",
    tag: "Spirit of Embers",
    desc: "Forged in wildfire, her antlers are charred branches that refuse to die. A guardian of scorched lands.",
    img: IMG_IVY,
    accent: "#D04C1F",
    tint: "#FBE1CC",
  },
  {
    id: 3,
    name: "BOOGLE",
    role: "The Sunwing",
    tag: "Heart of the Canopy",
    desc: "A cheerful spirit with feathers of jungle sun. Always the first to greet the morning with a song.",
    img: IMG_BOOGLE,
    accent: "#7D5BC9",
    tint: "#E6DCFB",
  },
  {
    id: 4,
    name: "FIREWOLF",
    role: "The Leafplume",
    tag: "Whisper of the Grove",
    desc: "Curious, kind, and crowned with autumn. His feathers shift colors with the seasons of his mood.",
    img: IMG_FIREWOLF,
    accent: "#9CA336",
    tint: "#EEEFC9",
  },
];

export const legendCards = [
  {
    n: "1",
    title: "The Crossing",
    text: "Four souls from four worlds awoke in bodies not their own. A reefkeeper, a burning stag, a sunwing, a leafplume \u2014 each carrying a memory that was never theirs.",
  },
  {
    n: "2",
    title: "The Bond",
    text: "Swapped is more than a collection. Each character holds a fragment of the story \u2014 their colors, their tells, their quiet songs. Together they form a chorus.",
  },
  {
    n: "3",
    title: "The Path",
    text: "We are building a small, real universe \u2014 art-first, community-driven, no empty promises. Holders walk this story with us, one swap at a time.",
  },
];

export const faqs = [
  {
    q: "What is Swapped Character?",
    a: "Swapped Character is a curated collection of 333 hand-crafted NFTs inspired by the Swapped Netflix film universe. Each piece is more than a PFP \u2014 it's a character with a name, a role, and a thread in a larger story we're slowly unfolding with the community.",
  },
  {
    q: "Why the name \"Swapped\"?",
    a: "The lore centers around four souls who woke up in the wrong worlds \u2014 a reefkeeper in a forest, a stag in a storm, and so on. \"Swapped\" is the moment that started everything.",
  },
  {
    q: "How big is the collection?",
    a: "333 total supply on Ethereum. Small, intentional, and curated \u2014 every piece is hand-finished and meant to find a real owner, not a flip.",
  },
  {
    q: "What is the mint price?",
    a: "Mint price is tiered based on your access:\n\n\u2022 FREE MINT for GTD (Guaranteed)\n\u2022 FREE MINT for FCFS (First Come, First Served)\n\u2022 FREE MINT for PUBLIC\n\nMaximum 2 mints per wallet during the WL window. Plus standard Ethereum gas fees.",
  },
  {
    q: "How will the WL distribution work?",
    a: "WL Distribution (333 Supply)\n\u2022 3 spots reserved for the team and treasury\n\u2022 100 spots for GTD\n\u2022 230 spots FCFS (first come, first served)",
  },
  {
    q: "When is the mint date?",
    a: "Mint date is TBA (To Be Announced). Follow our socials to be the first to know when it goes live. The pulse next to MINT DATE on the homepage will turn into a live countdown once announced.",
  },
  {
    q: "Where will it launch?",
    a: "Launching on Ethereum mainnet. Marketplace and launchpad details will be announced closer to mint day.",
  },
  {
    q: "Do holders own the IP of their character?",
    a: "Yes. Holders are granted full commercial IP rights to the character they own, so you can build, merch, animate, and tell stories with your Swapped.",
  },
  {
    q: "What makes Swapped different?",
    a: "We're not chasing hype. Swapped is small (333), story-led, and design-first. Every character has its own role in the universe, and the community shapes where the story goes next.",
  },
  {
    q: "Is there a roadmap?",
    a: "Yes \u2014 a soft one, kept honest:\n\n/Phase 0: Mint of 333 Swapped Characters on Ethereum (FREE), community formation.\n/Phase 1: Continuous art + lore drops to deepen each character.\n/Phase 2: Animated shorts and collaborative story chapters with holders.\n/Phase 3: A connected second collection within the Swapped universe.\n/Phase 4: Ongoing evolution \u2014 driven by the people who hold the story.\n\nNo fake promises. Just souls in motion.",
  },
];

export const footerLinks = [
  { label: "Twitter", href: "#" },
  { label: "Discord (soon)", href: "#" },
  { label: "OpenSea (soon)", href: "#" },
  { label: "Roadmap", href: "#" },
];

export const applyTasks = [
  { id: 1, label: "Follow us on X", cta: "Follow", icon: "bell" },
  { id: 2, label: "Like the Pinned Post", cta: "Like Post", icon: "heart" },
  { id: 3, label: "Retweet the Pinned Post", cta: "Retweet", icon: "repeat" },
  { id: 4, label: "Comment Your Favorite Character", cta: "Comment", icon: "message" },
];
